/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Meeting_Report_ProvenanceInputs */



/**
* | output |
* | --- |
* | "Written by Wundo on {date}." |
*
* @param {Meeting_Report_ProvenanceInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_report_provenance = /** @type {((inputs: Meeting_Report_ProvenanceInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Report_ProvenanceInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Door Wundo opgesteld op ${i?.date}.`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Rédigé par Wundo le ${i?.date}.`)
	return /** @type {LocalizedString} */ (`Written by Wundo on ${i?.date}.`)
});